/* flow */
import React from 'react'

export default () => 
  <div className="ui segment ac-loader">
    <div className="ui active dimmer">
      <div className="ui large loader"></div>
    </div>
  </div>





// WEBPACK FOOTER //
// ./src/Loader.js